module.exports = __webpack_public_path__ + "img/unica-logo.02f7ac92.png";